import { h, Component } from 'preact';
import {Loading, Button, Col, Row, Container, Input, Link} from 'components/elements'
import {CreditCard} from 'components/groups'
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import style from './style'
import {SessionActions, SelectedCardActions, CardActions} from 'actions'
import processForm from './processForm';
import _ from 'lodash'
import  {defer, classNames} from 'lib/helpers'

@connect((state)=> state)
export default class Payment extends WidgetComponent {
	constructor(props){
        super(props)
        this.state = {
            newCard: false,
            style: {
                height: 0
            },
            nameOnCard: [
                props.session.account.firstName,
                props.session.account.lastName
            ].join(' '),
            errors: {},
            address: props.session.account.address,
            zip: props.session.account.zip
        }
        
        this.addCard = this.addCard.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleGravityResponse = this.handleGravityResponse.bind(this)
        this.handleSelectCard = this.handleSelectCard.bind(this)
        this.handleAddressChange = this.handleAddressChange.bind(this)
        this.handleZipChange = this.handleZipChange.bind(this)
    }
    addCard(){
        this.setState({
            newCard: true
        })
    }
    componentDidUpdate(){
        if(this.state.newCard && !this.state.hostedForm){
            this.setState({
                hostedForm: true
            })
            CardActions.createToken().then(()=>{
                this.setState({
                    hostedForm: processForm(this.props.session.gravity.token, {
                        onTransactionSuccess: this.handleGravityResponse,
                        onFieldError: (e)=>{
                            this.setState({
                                errors: {
                                    ...(this.state.errors || {}),
                                    [`${e.fieldId}`]: e.result
                                }
                            }, ()=>{
                                this.setState({
                                    spinner: false
                                })
                            })
                        }
                    }),
                    newCardVisible: false
                }, ()=>{
                    const iframes = document.querySelectorAll('iframe#ccNumIframe,iframe#expDateIframe,iframe#secCodeIframe')
                    
                    let loadedIframes = [defer(), defer(), defer()]
                    for(let [i, iframe] of iframes.entries()){
                        iframe.setAttribute('scrolling', 'no')
                        iframe.onload = ()=>{
                            loadedIframes[i].resolve()
                        }
                    }
                    
                    let height = this.state.hostedForm._fieldSetUp.cardNumber.styles.height.replace('px', '')
                    height = parseInt(height)
                    Promise.all(loadedIframes).then(()=>{
                        this.setState({
                            newCardVisible: true,
                            style: {
                                height:  height + 10
                            }
                        })
                    })
                })
            })
        }
    }
    onSubmit(){
        if(!this.state.spinner){
            this.setState({
                spinner: true,
                errors: {}
            }, ()=>{
                this.state.hostedForm.process()
            })
        }
    }
    
    // UNUSED ONLY FOR TESTING
    spoofSubmit(){
        this.handleGravityResponse({
            accountExpiryDate: '0220',
            maskedAccount: 'XXXXXXXXXXXX2224',
            accountCardType: 'VS',
        })
    }

    handleGravityResponse(data){
        CardActions.create({
            expMonth: data.accountExpiryDate.slice(0, 2),
            expYear: data.accountExpiryDate.slice(2, 4),
            cardNumber: data.maskedAccount,
            cardType: data.accountCardType,
            name: this.state.nameOnCard,
            zip: this.state.zip,
            address: this.state.address,
            gravityID: data.uniqueTransId 
        }).then(()=>{
            this.componentDidSubmit()
            this.setState({
                spinner: false
            })
        })
    }
    handleNameChange(e){
        this.setState({
            nameOnCard: e.target.value
        })
    }
    handleAddressChange(e){
        this.setState({
            address: e.target.value
        })
    }
    handleZipChange(e){
        this.setState({
            zip: e.target.value
        })
    }
    get cards(){
        return _.sortBy(
            Object.values(this.props.cards || {}),
            'createdAt'
        )
    }
    handleSelectCard(card, e){
        e.preventDefault()

        SelectedCardActions.set(card)
        this.componentDidSubmit()
    }
    get initialName(){
        return [
            this.props.session.account.firstName,
            this.props.session.account.lastName
        ].join(' ')
    }
	render() {
        const cardVisible = {}
        cardVisible[style.cardVisible] = this.state.newCardVisible

		return (
            <div class={style.textCenter}>
                <Row>
                    <Col span={{xs: 24, md: 12}}>
                        <strong>Select Card</strong>
                        {this.cards.map((card)=>
                            <div>
                                <Link onClick={this.handleSelectCard.bind(null, card)} noStyle={true}>
                                    <CreditCard card={card} />
                                </Link>
                            </div>
                        )}
                        {this.state.newCard ? (
                            <Container>
                                <div class={classNames(style.card, cardVisible)}>
                                    <div class={style.inputGroup}>
                                        <strong>Name on Card</strong>
                                        <Input 
                                            dark={true}
                                            required={true}
                                            type='text'
                                            name='firstName'
                                            id='firstName'
                                            placeholder={'John Doe'}
                                            onChange={this.handleNameChange} 
                                            value={this.state.nameOnCard}
                                        />
                                    </div>
                                    <div class={style.inputGroup}>
                                        <strong>Address</strong>
                                        <Input 
                                            dark={true}
                                            required={true}
                                            type='text'
                                            name='address'
                                            id='address'
                                            placeholder={'65 What Lane'}
                                            onChange={this.handleAddressChange} 
                                            value={this.state.address}
                                        />
                                    </div>
                                    <div class={style.inputGroup}>
                                        <strong>Zipcode</strong>
                                        <Input 
                                            dark={true}
                                            required={true}
                                            type='text'
                                            name='zip'
                                            id='zip'
                                            placeholder={'2543'}
                                            onChange={this.handleZipChange}
                                            value={this.state.zip}
                                        />
                                    </div>
                                    <div class={style.inputGroup}>
                                        <strong>Card Number</strong>
                                        <div id="cardNumberContainer" class={[style.input, style.cardField].join(' ')} style={{ height: this.state.style.height }}></div>
                                        <div class={style.error}>
                                            {this.state.errors.card_number}
                                        </div>
                                    </div>
                                    <div class={style.inputGroup}>
                                        <strong>Expiration</strong>
                                        <div id="expirationDateContainer" class={[style.input, style.cardField].join(' ')} style={{ height: this.state.style.height }}></div>
                                        <div class={style.error}>
                                            {this.state.errors.card_expiration_date}
                                        </div>
                                    </div>
                                    <div class={style.inputGroup}>
                                        <strong>Security Code:</strong>
                                        <div id="securityCodeContainer" class={[style.input, style.cardField].join(' ')} style={{ height: this.state.style.height }}></div>
                                        <div class={style.error}>
                                            {this.state.errors.card_security_code}
                                        </div> 
                                    </div>
                                    <br />
                                    <Button spinner={this.state.spinner} onClick={this.onSubmit}>Save</Button>
                                </div>
                                {!this.state.newCardVisible && 
                                    <Loading class={style.loading} />
                                }
                            </Container>
                        ):(
                            <div>
                                <Button spinner={this.state.spinner} onClick={this.addCard}>Add Card</Button>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./components/templates/Payment/index.js